export interface TopicDetail {
  id: string;
  lead: string;
  sections: { heading: string; paragraphs: string[] }[];
  takeaways: string[];
}

export const topicDetails: TopicDetail[] = [
  {
    id: 'topic-01',
    lead: '本周娱乐相关线索数量明显增多，但真正值得跟进的只有三条。我们按时间顺序把它们排列出来，并标注每条线索的来源与可信度区间。',
    sections: [
      {
        heading: '线索一：最早出现的时间点',
        paragraphs: [
          '这条线索最早出现在讨论区的深夜时段，发帖者只提供了一张模糊的现场照片，没有文字说明。按照我们的判断标准，单一来源加上缺乏上下文，可信度只能给到偏低区间。',
          '不过它的价值在于时间最早。后续两条线索都与它的时间点吻合，这就让整条时间线变得可以互相参照，而不再是孤立的碎片。',
        ],
      },
      {
        heading: '线索二：来自多个方向的印证',
        paragraphs: [
          '第二条线索在次日上午出现，附有较完整的行程描述。与第一条相比，它的细节更具体，也更容易被证伪。',
          '值得注意的是，这条线索与第一条在关键时间点上只有十分钟的偏差。两个独立来源出现如此接近的描述，通常意味着背后存在一个共同的事实基础。',
        ],
      },
      {
        heading: '线索三：需要谨慎对待的一条',
        paragraphs: [
          '第三条线索传播最快，但来源最模糊。它引用了「知情人士」的说法，却没有任何可核验的细节，这类内容在过往经验中准确率并不稳定。',
          '我们把它列出来，是为了让读者看到热度与可信度并不总是正相关。传播快不代表更接近事实。',
        ],
      },
    ],
    takeaways: [
      '三条线索在时间点上互相印证，整条时间线基本成立。',
      '来源越具体的线索，越容易验证，也越值得优先关注。',
      '传播速度与可信度无关，热度高不等于更准确。',
    ],
  },
  {
    id: 'topic-02',
    lead: '新品爆料里真假参半，普通用户最容易被精美的渲染图和夸张的参数带偏。下面这套判断方法不需要专业知识，五步就能筛掉大部分噪音。',
    sections: [
      {
        heading: '第一步：看参数逻辑是否自洽',
        paragraphs: [
          '真实的爆料往往参数之间是互相支撑的，比如更大的屏幕通常对应更高的机身重量。如果一条爆料里所有参数都比上一代更好、同时机身还更轻更薄，就要多留个心眼。',
          '参数逻辑自洽，是判断一条爆料是否经过认真整理的第一道门槛。',
        ],
      },
      {
        heading: '第二步：检查渲染图的细节一致性',
        paragraphs: [
          '渲染图是最容易被识破的地方。摄像头排列、按键位置、屏幕开孔这些细节，在不同角度的图中必须保持一致。',
          '如果一张渲染图的正反面细节对不上，那么它大概率是拼凑出来的，图本身的可靠性就很低。',
        ],
      },
      {
        heading: '第三到五步：时间点、渠道与交叉验证',
        paragraphs: [
          '发布时间点是第三个信号。距离预期发布还有很久却出现高度完整的信息，通常需要打折扣；临近发布才出现的细节，可信度会更高。',
          '第四个信号是渠道。长期发布准确内容的账号，历史命中率可以参考；新账号突然放出重磅消息则要谨慎。',
          '最后一步是交叉验证。把同一时间段的几条爆料并排比较，看它们是否指向同一个结论，这是最有效也最容易被忽略的一步。',
        ],
      },
    ],
    takeaways: [
      '参数之间要能互相支撑，全面领先又更轻薄通常可疑。',
      '渲染图的各个角度细节必须一致。',
      '越临近发布出现的细节，可信度通常越高。',
      '交叉验证是筛掉噪音最有效的一步。',
    ],
  },
  {
    id: 'topic-03',
    lead: '我们统计了一个月内财经讨论区的帖子表现，发现一个有意思的现象：附有数据来源的复盘帖，平均互动量明显高于预测帖。',
    sections: [
      {
        heading: '复盘帖为什么更受欢迎',
        paragraphs: [
          '复盘帖的价值在于可验证。它讲述的是已经发生的事情，读者可以对照公开信息自行核对，讨论也因此更容易聚焦。',
          '相比之下，预测帖依赖假设，一旦前提变化，整篇内容就失去参考价值，评论区也容易变成观点对立的战场。',
        ],
      },
      {
        heading: '数据来源带来的信任感',
        paragraphs: [
          '在同为复盘帖的情况下，附上数据来源的帖子互动量还要再高出一截。这说明读者对「可追溯」这一点非常在意。',
          '一个简单的来源标注，就能显著降低读者的判断成本，这也是我们整理内容时坚持标注出处的原因。',
        ],
      },
    ],
    takeaways: [
      '复盘帖因为可验证，长期参考价值更高。',
      '标注数据来源能明显提升内容的可信度。',
      '预测类内容建议同时写明前提假设与失效条件。',
    ],
  },
  {
    id: 'topic-04',
    lead: '一次完整的消费纠纷从下单到解决，往往要经历好几个环节。我们把一位读者的真实沟通记录整理成时间线，并把每一步的关键话术模板保留了下来。',
    sections: [
      {
        heading: '第一阶段：发现问题与固定证据',
        paragraphs: [
          '收到商品后第一时间检查，是整件事里最关键的一步。发现问题后立刻拍照、录屏，并保留完整的开箱过程，这些都会成为后续沟通的依据。',
          '很多人吃亏在于证据不足，而不是道理不占理。',
        ],
      },
      {
        heading: '第二阶段：第一次沟通要讲清楚诉求',
        paragraphs: [
          '第一次沟通的重点是把事实和诉求分开说。先说事实：什么时候下单、什么时候收到、问题是什么；再说诉求：希望换货、退款还是补偿。',
          '把诉求说清楚，能避免来回拉扯浪费好几个回合。',
        ],
      },
      {
        heading: '第三阶段：升级与留痕',
        paragraphs: [
          '如果第一次沟通没有得到明确答复，就要在平台内留下完整的沟通记录，并明确提出希望的处理时限。',
          '记录留痕不仅是为了后续升级，也是提醒对方这次沟通是被完整记录的。',
        ],
      },
    ],
    takeaways: [
      '发现问题第一时间固定证据，比讲道理更重要。',
      '沟通时先讲事实，再讲诉求，减少来回拉扯。',
      '全程在平台内留痕，便于后续升级处理。',
    ],
  },
  {
    id: 'topic-05',
    lead: '热点事件刚出现时，信息往往是不完整的。在按下转发或评论之前，先问自己三个问题，可以避免让情绪跑在事实前面。',
    sections: [
      {
        heading: '问题一：信息来源是否只有一处',
        paragraphs: [
          '如果一条消息在多个平台上出现，但内容完全一致、都指向同一个出处，那它本质上仍然是单一来源。',
          '单一来源不等于错误，但需要等待更多印证再下判断。',
        ],
      },
      {
        heading: '问题二：时间线是否完整',
        paragraphs: [
          '很多误解来自只看最新的那一条。把相关帖子按时间顺序读一遍，往往会发现前面还有关键背景被省略了。',
          '时间线越完整，结论越可靠。',
        ],
      },
      {
        heading: '问题三：我的结论是否下得太快',
        paragraphs: [
          '事件初期形成的结论，在信息补全后经常需要修正。承认这一点不是墙头草，而是对事实负责。',
          '讨论区最珍贵的品质，是允许自己在新信息出现后改变看法。',
        ],
      },
    ],
    takeaways: [
      '同一内容多渠道转发，仍可能只有一个来源。',
      '按时间顺序读完整条时间线，能避免被片段误导。',
      '允许结论随新信息修正，是理性讨论的基础。',
    ],
  },
  {
    id: 'topic-06',
    lead: '转会期的传闻数量远超最终官宣，想在信息洪流里保持清醒，关键是建立几个可靠的交叉验证渠道。',
    sections: [
      {
        heading: '优先看俱乐部与联赛官方渠道',
        paragraphs: [
          '官方渠道发布的信息最慢，但准确性最高。把官方账号作为最终确认的锚点，可以过滤掉绝大部分噪音。',
          '在官方确认之前，一切都可以视为讨论素材，而不是结论。',
        ],
      },
      {
        heading: '长期跟队记者的历史准确率',
        paragraphs: [
          '跟队记者的价值在于长期积累。与其看单条消息，不如回顾他们过去一年的命中情况，再决定给多少信任。',
          '历史准确率是判断一个信息源是否值得关注的最实际指标。',
        ],
      },
    ],
    takeaways: [
      '官方渠道是最终确认的锚点。',
      '用长期命中率评估信息源，而不是单条消息。',
      '官宣之前的传闻，都应视为待验证内容。',
    ],
  },
  {
    id: 'topic-07',
    lead: '第一次来到爆料专区，很多人会在首页停留很久却不知道点哪里。这份一小时路线图把最值得做的几件事排好了顺序。',
    sections: [
      {
        heading: '前二十分钟：熟悉首页与快速入口',
        paragraphs: [
          '先花二十分钟把首页从上到下看一遍，重点是快速入口区域与主题分类。不用急着点进去，先建立整体的空间感。',
          '清楚每个入口大致通向什么内容，后面的访问效率会高很多。',
        ],
      },
      {
        heading: '中间二十分钟：挑一个方向深读',
        paragraphs: [
          '从你最有兴趣的分类里挑三到五篇内容完整读完，关注它们的信息来源与时间线。',
          '深读几篇，比走马观花看几十条更能建立判断力。',
        ],
      },
      {
        heading: '最后二十分钟：订阅并收藏',
        paragraphs: [
          '把首页加入书签，再在页脚订阅每周更新汇总。这样你就完成了从「偶然访问」到「稳定跟进」的转变。',
          '好的浏览习惯，往往比一次性看多少内容更重要。',
        ],
      },
    ],
    takeaways: [
      '先建立空间感，再深入阅读。',
      '深读几篇胜过快速划过几十条。',
      '收藏与订阅能让跟进变成习惯。',
    ],
  },
  {
    id: 'topic-08',
    lead: '经常有人问，为什么有些话题看起来很热闹却排在后面，有些刚出现的帖子却冲到了前面。这里把站内热度排序的考虑维度公开说明一下。',
    sections: [
      {
        heading: '互动速度：短时间内是否有人接话',
        paragraphs: [
          '热度首先看互动速度。一个话题在短时间内收到较多回复，说明它正在被讨论，排序会相应靠前。',
          '这解释了一个现象：老帖即使总回复很多，也可能不如新话题靠前。',
        ],
      },
      {
        heading: '跟帖深度：讨论是否持续深入',
        paragraphs: [
          '单纯的转发和点赞不参与深度计算，我们更看重有内容的跟帖。讨论越深入，话题的排序权重越高。',
          '这样做的目的是让有价值的讨论留在更显眼的位置。',
        ],
      },
      {
        heading: '时间衰减：让位给新内容',
        paragraphs: [
          '所有话题都会随着时间自然衰减，这是为了保证首页始终呈现正在发生的事。',
          '衰减并不意味着内容失去价值，你仍然可以通过分类与搜索随时找到它们。',
        ],
      },
    ],
    takeaways: [
      '互动速度决定话题是否正在被讨论。',
      '有内容的跟帖比单纯转发更能提升权重。',
      '时间衰减让首页保持新鲜，但不影响内容检索。',
    ],
  },
];